export const TRIAL_CONTACTS_LIMIT = 10
export const TRIAL_CONTACTS_LIMIT_LABEL = `You can select no more than ${TRIAL_CONTACTS_LIMIT} contacts for Power Dialer`
export const POWER_DIALER_EMPTY_NAME_ERROR = 'Please enter Power Dialer name'
